import React, { useEffect, useState } from "react";
import Select from "react-select";
import {GENERIC_PAGINATED_KEY_VALUE_LIST, getApiPath} from "../../../api/ApiConst";
import apiCaller from "../../../api/ApiCaller";

const CollectionObjectDropdown = ({ field = {}, name, value, onChange }) => {
  const [optionList, setOptionList] = useState([]);
  const selectedOption = optionList.find((option) => option.value === value);

  useEffect(() => {
    // Try different possible locations for keyAttribute and valueAttribute
    const keyAttribute = field?.keyValuePair?.keyAttribute || field?.config?.keyAttribute;
    const valueAttribute = field?.keyValuePair?.valueAttribute || field?.config?.valueAttribute;
    
    if (!keyAttribute || !valueAttribute) {
      return;
    }

    if (!field?.referenceTablePath) {
      return;
    }

    if(field?.referenceTablePath === "null" || field?.referenceTablePath === "undefined"){
      return;
    }

    const tableUrl = getApiPath(field?.referenceTablePath, GENERIC_PAGINATED_KEY_VALUE_LIST);
    
    const payload = {
      page: 0,
      size: 200,
      searchFilters: [],
      sortRules: [],
      keyAttribute,
      valueAttribute,
    };

    apiCaller.callPostApi(
      tableUrl,
      payload,
      {},
      (response) => {
        const data = response?.data;
        const options = Array.isArray(data)
          ? data.map((pair) => ({ label: pair.value, value: pair.key }))
          : [];
        setOptionList(options);
      },
      (error) => {
        console.error("CollectionObjectDropdown API error:", error);
      }
    );
  }, [field, field?.referenceTablePath, field?.keyValuePair, field?.config]);

  return (
    <>
      <Select
        name={name}
        value={selectedOption ? { label: selectedOption.label, value: selectedOption.value } : null}
        options={optionList}
        onChange={(event) => {
          onChange({
            target: { name, value: event?.value },
          });
        }}
        placeholder="Select an option..."
        className="react-select-container"
      />
    </>
  );
};

export default CollectionObjectDropdown;
